import type { TokenPayload } from 'app/services/auth';

export const ONE_FIIT_TOKEN_EXCHANGE_GRANT_TYPE = 'urn:ietf:params:oauth:grant-type:token-exchange';
export const ONE_FIIT_ID_TOKEN_SUBJECT_TOKEN_TYPE = 'urn:ietf:params:oauth:token-type:id_token';

export type OneFiitTokenResponse = {
  accessToken: string;
  refreshToken: string;
  accessTokenExpiresAt?: string;
  refreshTokenExpiresAt?: string;
  success?: boolean;
  message?: string;
};

export const parseOneFiitTokenResponse = ({
  accessToken,
  refreshToken,
  refreshTokenExpiresAt,
}: OneFiitTokenResponse): TokenPayload => ({
  accessToken,
  refreshToken,
  refreshTokenExpiresAt,
});
